// Maps the OLD backend error payloads (unchanged shape: `{status, data}` from
// apiSlice.js's axios error handler, `data.error` is typically a plain string) onto the
// NEW UI's error taxonomy (persistent inline alert vs. transient toast vs. field error).
// This is the one place that decides which Figma error state a given API failure maps to
// — adjust the keyword heuristics here if the backend starts returning error codes instead
// of free-text messages.

const getMessage = (error) => {
    if (!error) return null;
    const data = error.data;
    if (typeof data === 'string') return data;
    if (data && typeof data.error === 'string') return data.error;
    return 'Something went wrong.';
};

// For updateLoginSession / updateSignUpSession failures on the main login card.
export const classifyLoginError = (error) => {
    const message = getMessage(error) || 'Something went wrong.';
    const lower = message.toLowerCase();

    if (lower.includes('no account') || lower.includes('not found')) {
        return {kind: 'alert', title: 'No account found', description: message};
    }
    if (error?.status === 429 || lower.includes('rate limit') || lower.includes('too many')) {
        return {kind: 'toast', variant: 'error', title: 'Rate Limited', description: message};
    }
    return {kind: 'toast', variant: 'error', title: 'Something went wrong', description: message};
};

// For updateSsoLoginSession (Google) failures — Figma always shows this as a toast.
export const classifySsoError = (error) => ({
    kind: 'toast',
    variant: 'error',
    title: 'Login failed',
    description: getMessage(error) || 'Unable to login with Google. Please try again or use email instead.'
});

// For TokenVerification (magic-link) failures — decides which terminal StatusCard to show.
export const classifyTokenError = (error) => {
    const message = getMessage(error) || '';
    const lower = message.toLowerCase();

    if (lower.includes('expired')) return 'expired';
    if (lower.includes('used')) return 'already-used';
    return null; // unrecognized — caller falls back to the old navigate('/login') behavior
};
